import React from "react"

class MakeAdjustmentButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      folio_item_type: null
    }
    this.onAdd = this.onAdd.bind(this);
  };

  render(){
      let href = (this.href())
  
    return(
      <div className="add-charge-button">
        <AddButton model="FolioItemType" text={I18n.t('make_adjustment')} buttonClasses="btn btn-primary" reservation_segment={this.props.reservation_segment} new_button={false} onAdd={this.onAdd} />
        <a ref="hiddenLink" data-fullscreen="true" data-nested="true" href={href} className="modal-iframe" style={{ display: 'none' }}></a>
      </div>
    );
  };

  href(){
    if(this.state.folio_item_type && this.state.folio_item_type.id){
      return `/admin/folio-items/${this.props.data[0].parent_folio_item_id}/make-adjustment?&folio_item_type_id=${this.state.folio_item_type.id}` 
    } else{return null}
  };

  onAdd(json) {
    this.setState({ folio_item_type: json},  () => {
      $(this.refs.hiddenLink).trigger('click');
    });

  };
}

export default MakeAdjustmentButton